import React, { useCallback, useContext } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { ArchivalAidMetadata } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';
import { DialogContext } from 'components/dialog/dialog-context';
import { BasicQuoteDialog } from 'components/dialog/aisuk-dialogs/aisuk-basic-quote-dialog';
import { getArchivalAidQuote } from './utils/get-archival-aid-quote';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
    dialog: {
      width: 600,
    },
    dialogTitle: {
      fontWeight: 'bold',
    },
    dialogActions: {
      padding: '8px 24px',
    },
    quote: {
      '& textarea': {
        lineHeight: 1.5,
      },
    },
  })
);

export function ArchivalAidQuote({ item }: GridActionButtonComponent) {
  const classes = useStyles();
  const { open } = useContext(DialogContext);

  const archivalAid = item as ArchivalAidMetadata;

  const quote = getArchivalAidQuote(archivalAid, true);

  const handleOpenQuoteDialog = useCallback(() => {
    open({
      initialValues: {
        quoteContent: quote,
      },
      size: 'sm',
      Content: BasicQuoteDialog,
    });
  }, [open, quote]);

  return (
    <Button
      component="span"
      variant="outlined"
      color="primary"
      className={classes.navigationButton}
      onClick={handleOpenQuoteDialog}
    >
      Vytvoř citaci
    </Button>
  );
}
